/** Путь от корня до раздела: по нему открывается ссылка из чата. */
import type { Catalog } from '@/shared/types';
import type { Screen } from './nav';

/** Заголовок меню без служебного префикса из чат-админки. */
function menuTitle(menu: { title: string }): string {
  return menu.title.replace(/^Submenu:\s*/i, '');
}

/** Цепочка экранов от корня до раздела: крошки и «назад» должны работать. */
export function pathToList(catalog: Catalog, listId: string): Screen[] | null {
  for (const menu of Object.values(catalog.menus)) {
    const button = menu.buttons.find(
      (item) => item.action_type === 'product_list' && item.target_id === listId,
    );
    if (!button) continue;

    const chain: Screen[] = [];
    let node: (typeof catalog.menus)[string] | undefined = menu;
    while (node) {
      chain.unshift({
        type: 'menu',
        id: node.id,
        title: node.id === catalog.root_id ? 'Каталог' : menuTitle(node),
      });
      node = node.parent_id ? catalog.menus[node.parent_id] : undefined;
    }
    chain.push({ type: 'list', id: listId, title: button.text });
    return chain;
  }
  return null;
}
